import {
  getSuppliers,
  createSupplier,
  editSupplier,
  getSupplierById,
  deleteSupplier,
} from "@/http/setup/suppliers";

export default {
  namespaced: true,
  state: {
    supplierList: [],
    formError: null,
    createSupplier: null,
    updateSupplier: null,
    supplierById: {},
  },
  actions: {
    async setSupplierList({ commit }) {
      const resp = await getSuppliers();
      commit("SET_SUPPLIER_LIST", resp.data.pageItems);
      return resp;
    },
    async deleteSupplierAction({ commit }, id) {
      try {
        let res = await deleteSupplier(id);
        commit("RESET_SUPPLIER_LIST", id);
        return res;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async setPostSupplier({ commit, state }, data) {
      try {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        if (state.createSupplier != null) commit("SET_POST_SUPPLIER", null);
        const resp = await createSupplier(data);

        if (resp.data.resourceId) {
          commit("SET_POST_SUPPLIER", resp.data.resourceId);
          return resp;
        }
      } catch (e) {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        commit("FORM_ERROR", e.message.errors[0].defaultUserMessage);

        return e.message;
      }
    },
    async setPutSupplier({ commit, state }, data) {
      try {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        if (state.createSupplier != null) commit("SET_PUT_SUPPLIER", null);

        const resp = await editSupplier(data.id, data.supplier);

        if (resp.data.resourceId) {
          commit("SET_PUT_SUPPLIER", resp.data.resourceId);
          return resp;
        }
      } catch (e) {
        if (state.formError != null) {
          commit("FORM_ERROR", null);
        }
        commit("FORM_ERROR", e.message.errors[0].defaultUserMessage);

        return e.message;
      }
    },
    async setSupplierById({ commit }, data) {
      try {
        const response = await getSupplierById(data);
        commit("SET_SUPPLIER_BY_ID", response.data[0]);
      } catch (e) {}
    },
  },
  mutations: {
    ["SET_SUPPLIER_LIST"](state, payload) {
      Object.assign(state, { supplierList: payload });
    },
    ["FORM_ERROR"](state, payload) {
      Object.assign(state, { formError: payload });
    },
    ["SET_POST_SUPPLIER"](state, payload) {
      Object.assign(state, { createSupplier: payload });
    },
    ["SET_PUT_SUPPLIER"](state, payload) {
      Object.assign(state, { updateSupplier: payload });
    },
    ["SET_SUPPLIER_BY_ID"](state, payload) {
      Object.assign(state, { supplierById: payload });
    },
    RESET_SUPPLIER_LIST(state, id) {
      state.supplierList = state.supplierList.filter((el) => el.id !== id);
    }
  },
  getters: {
    getSupplierList(state) {
      return state.supplierList;
    },
    saveSupplierResponse(state) {
      return state.createSupplier;
    },
  },
};
